import React from "react";
import { BaseEdge, getSmoothStepPath, type EdgeProps } from "@xyflow/react";

export interface TriggerEdgeData extends Record<string, unknown> {
  mapping?: Record<string, string>;
  edgeType?: "trigger" | "tool" | "subteam" | "linear" | "final";
}

const TriggerEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}) => {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return <BaseEdge id={id} markerEnd={markerEnd} path={edgePath} style={style} />;
};

export default TriggerEdge;
